import OMT_UI_ScrollBarConfig from '../Scroll/OMT_UI_ScrollBarConfig';
import { OMT_UI_FriendsListItem } from './OMT_UI_FriendsListItem';
import OMT_UI_RoundedScrollArea from '../Scroll/OMT_UI_RoundedScrollArea';
/*
  generic friends list view
*/
export class OMT_UI_FriendsListView extends Phaser.Group {
    /**
     * constructor
     */
    constructor() {
        super(game);

        this.signals = {}; // add signals to this
    }

    /**
     * main init function. call manually or from extending Class
     * @param {number} itemHeight
     * @param {Phaser.Rectangle} scrollRect
     * @param {number} oddRowBgColor
     * @param {number} eventRowBgColor
     */
    init(itemHeight, scrollRect, oddRowBgColor, evenRowBgColor) {
        this._scrollRect = scrollRect;
        this.x = scrollRect.x;
        this.y = scrollRect.y;

        this._initScrollArea();
        this._initItems(itemHeight, oddRowBgColor, evenRowBgColor);
    }

    /**
     * init the scroll area
     */
    _initScrollArea() {
        const scrollRect = this._scrollRect.clone();
        scrollRect.x = 0;
        scrollRect.y = 0;
        const scrollBarConfig = new OMT_UI_ScrollBarConfig(null, null, null, 1, null, null, null, null, true);
        this._scrollArea = new OMT_UI_RoundedScrollArea(scrollRect, 15, scrollBarConfig);
        this.addChild(this._scrollArea);
    }

    /**
     * init list view items
     * @param {number} itemHeight
     * @param {number} oddRowBgColor
     * @param {number} eventRowBgColor
     */
    async _initItems(itemHeight, oddRowBgColor, evenRowBgColor) {
        const itemWidth = this._scrollRect.width;
        this._listItems = [];
        console.log("Friendslistview");
        const userList = await OMT.friends.getFriendsList();


        // create the item list and append them to the scroll view
        userList.forEach((friendData, index) => {
            const bgColor = index % 2 === 0 ? oddRowBgColor : evenRowBgColor;
            const listItem = this._createFriendListItem(friendData, itemWidth, itemHeight, bgColor);
            listItem.y = index * itemHeight;
            this._scrollArea.content.addChild(listItem);
            this._listItems.push(listItem);
        });
    }

    /**
     * create friendList item
     * @param {Object} friendData
     * @param {number} itemWidth
     * @param {number} itemHeight
     * @param {number} bgColor
     */
    _createFriendListItem(friendData, itemWidth, itemHeight, bgColor) {
        const listItem = new OMT_UI_FriendsListItem(friendData, itemWidth, itemHeight, bgColor);
        return listItem;
    }
}